export default [
  {
    text: 'Программы',
    to: { name: 'events', query: { sort: 'reviews' } },
    ico: 'org',
  },
];



// WEBPACK FOOTER //
// ./src/pages/menu.programms.js